import { Node, mergeAttributes } from '@tiptap/core'

export const TwoColumnWrapper = Node.create({
  name: 'twoColumnWrapper',

  group: 'block',

  content: 'block+',

  parseHTML () {
    return [
      { tag: 'div[data-type="two-column-wrapper"]' }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-type': 'two-column-wrapper', style: 'display:flex; gap:32px;' }),
      0
    ]
  }
})
